<template>
  <a-modal
    title="登录方式"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 18 },}"  :rules="rules">

        <a-form-model-item prop="loginTypes" label="登录方式">
          <a-checkbox-group v-model="loginTypes" :options="[{ label: '手动登录', value: '1' }, { label: '微信自动登录', value: '2', disabled: model.wechat!=='1' }]" />
        </a-form-model-item>
        <a-form-model-item v-if="loginTypes.indexOf('1')>=0" label="登录校验">
          <a-table :columns='columns' :dataSource='dataSource' :pagination='false'  rowKey='id' size='small'>
            <span slot="checkInfo" slot-scope="text,record,index">
                <a-select  v-model="record.fieldId" >
                   <a-select-option
                     v-for="(field,fi) in fieldList"
                     :key="fi"
                     :value="field.id">
                    {{ field.name }}
                  </a-select-option>
                </a-select>
             </span>
          </a-table>
          <a @click.stop='addField'>新增</a>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>

export default {
  name: 'LoginSettingModal',
  props:{
    fieldList:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  data () {
    return {
      visible: false,
      model: {},
      confirmLoading: false,
      rules:{
      },
      url: {
        // add: "/admin/help/add",
        // edit: "/admin/help/edit",
      },
      dataSource: [],
      loginTypes:[],
    }
  },
  computed: {
    columns(){
      return [
        {
          title: '#',
          align:'center',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '校验信息',
          dataIndex:'',
          align:'center',
          scopedSlots: { customRender: 'checkInfo' },
        },
        {
          title: '操作',
          align:'center',
          customRender: (text, record, index) => (<a onClick={event => this.removeField(index)}>删除</a>)
        }
      ]
    }
  },
  created () {

  },
  methods: {
    edit (record,loginSettingList) {
      this.dataSource = JSON.parse(JSON.stringify(loginSettingList))
      record = Object.assign({}, record)
      const loginTypes = []
      if(record.loginType1==='1'){
        loginTypes.push('1')
      }
      if(record.loginType2==='1'){
        loginTypes.push('2')
      }
      this.loginTypes = loginTypes
      this.model = record;
      this.visible = true;
    },
    close () {
      this.visible = false;
      this.$refs.form.clearValidate();
    },
    handleOk () {
      this.model.loginType1 ='0'
      this.model.loginType2 ='0'
      this.loginTypes.forEach(item=>{
        if(item==='1'){
          this.model.loginType1 ='1'
        }else if(item==='2'){
          this.model.loginType2 ='1'
        }
      })
      this.$emit('ok', this.model, this.dataSource);
      this.close();
    },
    handleCancel () {
      this.close()
    },


    addField() {
      this.dataSource.push({})
    },
    removeField(index) {
      this.dataSource.splice(index, 1)
    }


  }
}
</script>

<style scoped>

</style>
